"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../styler/utils");

var camelCache = new Map();
var dashCache = new Map();
var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes.length;
var testElement;

var testPrefix = function testPrefix(key) {
  if (typeof document === 'undefined') return;
  testElement = testElement || document.createElement('div');

  for (var i = 0; i < numPrefixes; i++) {
    var prefix = prefixes[i];
    var noPrefix = prefix === '';
    var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);

    if (prefixedPropertyName in testElement.style) {
      camelCache.set(key, prefixedPropertyName);
      dashCache.set(key, "" + (noPrefix ? '' : '-') + utils_1.camelToDash(prefixedPropertyName));
    }
  }
};

exports.default = function (key, asDashCase) {
  if (asDashCase === void 0) {
    asDashCase = false;
  }

  var cache = asDashCase ? dashCache : camelCache;
  if (!cache.has(key)) testPrefix(key);
  return cache.get(key) || key;
};